import { Box } from '@chakra-ui/react';
import {
  Heading,
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Badge } from 'components/ui/badge';
import TrendingIconUpSVG from '../CustomSVGs/TrendingIconUpSVG';
import { PropsWithChildren } from 'react';
import TrendingIconDownSVG from '../CustomSVGs/TrendingIconDownSVG';
import { Trend } from '../../models/score';

type Props = {
  circleStyle: 'solid' | 'outline';
  badgeColor: string;
  badgeStyle: 'solid' | 'outline';
  badgeText?: string;
  title: string;
  trend: Trend;
  value?: number;
};

export const PanelWidget = ({
  badgeColor,
  badgeStyle,
  badgeText,
  children,
  circleStyle,
  title,
  trend,
  value,
}: PropsWithChildren<Props>) => {
  const TrendIcon =
    trend === Trend.up ? TrendingIconUpSVG : TrendingIconDownSVG;

  return (
    <VStack
      borderColor={'cloud.200'}
      borderWidth={1}
      minH={'116px'}
      justifyContent={'space-around'}
      p={2}
      rounded={'lg'}
      w={'117px'}
    >
      <Text color={'secondary.500'} fontSize={'xs'} fontWeight={'normal'}>
        <Box
          bgColor={circleStyle === 'solid' ? badgeColor : undefined}
          borderWidth={1}
          borderColor={badgeColor}
          h={'9px'}
          mt={0.5}
          mr={1}
          rounded={'full'}
          w={'9px'}
        />

        {title}
      </Text>

      {/*
       * Sizes to its content rather than a fixed 75px box. The label used to be
       * set at 7px — not a step on the type scale, and small enough to read as a
       * rendering error — which existed to make "Large Correlation" fit that box.
       * At 2xs, the smallest real step, the text is 85px and overflowed. The
       * widget has ~99px of inner width, so letting the badge size itself fits
       * comfortably and survives a longer label, which the fixed width did not.
       */}
      {badgeText && (
        <Badge
          bgColor={badgeStyle === 'solid' ? badgeColor : 'transparent'}
          borderColor={badgeColor}
          color={badgeStyle === 'solid' ? 'white' : 'secondary.600'}
          fontSize={'2xs'}
          my={2}
          px={2}
          rounded={'full'}
          textAlign={'center'}
        >
          {badgeText}
        </Badge>
      )}

      <HStack alignItems={'center'}>
        <TrendIcon height={8} width={8} />

        <Heading color={'secondary.500'} fontSize={'2xl'} ml={2}>
          {value ?? '--'}
        </Heading>
      </HStack>

      {children}
    </VStack>
  );
};
